// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9c90a159","455":"0d1e05cc","977":"c4b8448e"}[chunkId] + ".chunk.js";
};